import React from 'react';

const PopupModal = (props) => {
  const {header, children, enableButton, cancel, apply} = props;
  return (
    <div className="popup-modal">
      <div className="popup-modal-header">
        <h3>{header}</h3>
      </div>
      <div className="popup-modal-content">
        {children}
        {enableButton &&
          <div className='popup-modal-buttonset-text-center'>
            <button className="cancel" onClick={cancel.fn}>
              {cancel.text}
            </button>
            <button className="apply" onClick={apply.fn}>
              {apply.text}
            </button>
          </div>
        }
      </div>
    </div>
  );
}

export default PopupModal;



// WEBPACK FOOTER //
// ./src/helpers/popupModal.js